import { render, staticRenderFns } from "./ToRemoteFile.vue?vue&type=template&id=1d5153f8&"
import script from "./ToRemoteFile.vue?vue&type=script&lang=js&"
export * from "./ToRemoteFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports